import {useCallback} from 'react';
import {atom, useRecoilState, useRecoilValue} from 'recoil';
import {IServiceFilters, ServiceOrder} from 'src/domains';
export interface IHomeFilter {
  filter: IServiceFilters;
  order: ServiceOrder;
}

export const DefaultHomeFilter: IHomeFilter = {
  filter: {
    online: undefined,
    ownerStatus: undefined,
    categories: undefined,
    gender: undefined,
    age: undefined,
    prefectures: undefined,
  },
  order: ServiceOrder.SERVICE_RECOMMENDATION,
};

export const homeFilter = atom<IHomeFilter>({
  key: 'homeFilter',
  default: DefaultHomeFilter,
});

export const useHomeFilter = () => {
  const [filter, setFilter] = useRecoilState<IHomeFilter>(homeFilter);

  const handleSet = useCallback(
    (v: IHomeFilter) => {
      setFilter(v);
    },
    [setFilter],
  );
  const handleReset = useCallback(() => {
    setFilter(DefaultHomeFilter);
  }, [setFilter]);

  return [
    filter,
    JSON.stringify(filter) !== JSON.stringify(DefaultHomeFilter),
    handleSet,
    handleReset,
  ] as const;
};
